import { Route } from "react-router-dom";
import {
  adminDashboard,
  rodDashboard,
} from "../components/Dashboard/DashboardLandingContent";
import DashboardLandingPage from "../pages/Landing/DashboardLandingPage";
import { Resources as RoDResources } from "./RoDDashboard/routes";
import { Resources as CtDResources } from "./CTDashboard/routes";
import { Resources as adminResources } from "./AdminDashboard/routes";
import enStrings from "../providers/i18nProvider/CustomStrings/enStrings";
const version = process.env.REACT_APP_VERSION ?? "0.0.0";

const dashboards = {
  rodDashboard: {
    app: "rodDashboard",
    description:
      "The Resource Optimization Dashboard is a portal that allows AWS Account owners and members of the Cost Optimization Team to monitor different Cost Optimization KPIs of related AWS resources for any product, with a structured, dynamic, and daily updated evidence-based approach.",
    title: "Resource Optimization",
    basename: "/rod",
    baseRoute: (
      <Route
        key="rodDashboard"
        path="/rod/*"
        element={
          <DashboardLandingPage
            app="rodDashboard"
            version={version}
            basename="/rod"
            resources={RoDResources}
            dashboard={rodDashboard}
          />
        }
      />
    ),
  },
  ctdDashboard: {
    app: "ctdDashboard",
    description: enStrings.nav.ctdDashboard.description,
    title: enStrings.nav.ctdDashboard.dashboardTitle,
    basename: "/ctd",
    baseRoute: (
      <Route
        key="ctdDashboard"
        path="/ctd/*"
        element={
          <DashboardLandingPage
            app="ctdDashboard"
            version={version}
            basename="/ctd"
            resources={CtDResources}
          />
        }
      />
    ),
  },
  adminDashboard: {
    app: "adminDashboard",
    title: "Admin Panel",
    description: "Monitor ingestions, user roles and the FAQ page.",
    basename: "/admin",
    baseRoute: (
      <Route
        key="adminDashboard"
        path="/admin/*"
        element={
          <DashboardLandingPage
            app="adminDashboard"
            version={version}
            dashboard={adminDashboard}
            basename="/admin"
            resources={adminResources}
          />
        }
      />
    ),
  },
};

export default dashboards;
